import { render, staticRenderFns } from "./Seguros.vue?vue&type=template&id=6b37fe9d&scoped=true"
import script from "./Seguros.vue?vue&type=script&lang=js"
export * from "./Seguros.vue?vue&type=script&lang=js"
import style0 from "./Seguros.vue?vue&type=style&index=0&id=6b37fe9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b37fe9d",
  null
  
)

export default component.exports